export const sv = {
  selectCompany: 'Välj företag',
  garage: 'Verkstad',
  carCare: 'Bilvård',
  roleOwner: 'Ägare',
  roleManager: 'Chef',
  roleMechanic: 'Mekaniker',
  roleStaff: 'Personal',
  navRequests: 'Förfrågningar',
  navQuotes: 'Offerter',
  navCalendar: 'Kalender',
  navJobs: 'Jobb',
  navServices: 'Tjänster',
  navReviews: 'Recensioner',
  navStaff: 'Personal',
  navAds: 'Annonser',
  navSettings: 'Inställningar',
  selectOtherCompany: 'Välj annat företag',
  switchCompany: 'Byt företag',
  notifTitle: 'Nytt',
  notifEmpty: 'Inget nytt',
  notifBooking: 'Bokat jobb',
  notifViewRequests: 'Alla förfrågningar',
  notifViewJobs: 'Alla jobb',
  logout: 'Logga ut',
}

export const en: typeof sv = {
  selectCompany: 'Select company',
  garage: 'Garage',
  carCare: 'Car care',
  roleOwner: 'Owner',
  roleManager: 'Manager',
  roleMechanic: 'Mechanic',
  roleStaff: 'Staff',
  navRequests: 'Requests',
  navQuotes: 'Quotes',
  navCalendar: 'Calendar',
  navJobs: 'Jobs',
  navServices: 'Services',
  navReviews: 'Reviews',
  navStaff: 'Staff',
  navAds: 'Ads',
  navSettings: 'Settings',
  selectOtherCompany: 'Select another company',
  switchCompany: 'Switch company',
  notifTitle: 'New',
  notifEmpty: 'Nothing new',
  notifBooking: 'Booked job',
  notifViewRequests: 'All requests',
  notifViewJobs: 'All jobs',
  logout: 'Log out',
}
